import { isNullish } from '@chainflip/utils/guard';
import { AnimatePresence } from 'motion/react';
import { Link } from '@/shared/components/atoms/Link';
import { DashboardModalWithCloseButton } from '@/shared/components/dashboards/Modal';
import Button from '@/shared/components/flip-ui-kit/Button';
import useSettingsStore from '@/shared/hooks/useSettingsStore';

export const LendingIntroductionModal = (): React.JSX.Element => {
  const { borrowTourStep, shouldIntroduceLending, setSetting } = useSettingsStore();

  const close = () => setSetting('shouldIntroduceLending', false);

  return (
    <DashboardModalWithCloseButton
      open={shouldIntroduceLending && isNullish(borrowTourStep)}
      onClose={close}
      afterLeave={close}
    >
      <AnimatePresence mode="wait">
        <div className="flex flex-col gap-y-3">
          <div className="font-aeonikMedium text-20 text-cf-white">
            Chainflip Lending 2.0 is here!
          </div>
          <ul className="ml-6 list-disc font-aeonikRegular text-14 text-cf-light-2">
            <li>Supply once, use as collateral</li>
            <li>Earn yield on your collateral</li>
            <li>Earn additional yield from Boost on BTC</li>
          </ul>

          <Link
            href="https://chainflip.io/blog/lending-2.0-supply-as-collateral-yield-on-your-supplied-btc-via-boost"
            target="_blank"
            className="font-aeonikMedium text-14 !text-cf-green-1"
            underline
          >
            Read more
          </Link>
          <img
            src="/lending-20-introduction.png"
            alt="Earn additional yield from Boost on BTC"
            className="block h-full w-full object-cover"
          />
          <Button onClick={close} type="primary-standard">
            Get started
          </Button>
        </div>
      </AnimatePresence>
    </DashboardModalWithCloseButton>
  );
};
